import React from 'react'

import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/datepicker-glass.css";

export default ({ header, value, onChangeText, prop, viewOnly, ...props }) => {

  return (
    <div style={{ margin: '8px 0' }}>
      <span htmlFor={prop} style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--text-secondary, #5a6b7b)', marginBottom: 3 }}>{header}</span>
      {!viewOnly && <DatePicker selected={value && moment(value).isValid() ? moment(value).toDate() : null} dateFormat={'yyyy-MM-dd'} className="form-control" placeholderText="YYYY-MM-DD" onChange={(date) => {
        onChangeText(prop, date);
      }} />}

      {/* moment(undefined) is "now", so an unset date used to render as today's
          date — a wrong value, not an empty one. Only format a real date, and
          drop the leading ": " that landed on its own line under the header. */}
      {!!viewOnly && (
        <div style={{ fontSize: 14, color: 'var(--text, #0f1f2e)' }}>
          {value && moment(value).isValid()
            ? moment(value).format('YYYY-MM-DD')
            : <span style={{ color: 'var(--text-muted, #9aa5b4)' }}>—</span>}
        </div>
      )}
    </div>);
}
